export default "__VITE_ASSET__CJmjzN2T__"